import { useState } from "react";
import CropPopup from "../LoanProduct/CropPopUp";
import { Button, Input, Popover, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useContext } from "react";
import { AasetupContext } from ".";
import PageLoader from "../../components/PageLoader";
import { useEffect } from "react";
import { IMAGE_BASE_URL } from "../../helpers/constants";
import { Controller, FormProvider, useForm } from "react-hook-form";
import axios, { apiAxios } from "../../axios/axios";
import { toast } from "react-toastify";
async function dataURItoBlob(url) {
    return await (await fetch(url)).blob();
}
const Aaedit = () => {
    const { setEditMode, isLoading, AAData, authData, refetch } =
        useContext(AasetupContext);
    const [showCrop, setShowCrop] = useState(false);
    const [croppedImage, setCroppedImage] = useState(false);
    const [image, setImage] = useState(null);
    const methods = useForm({
        defaultValues: {
            logo: "",
            s_no: "",
            company_name: "",
            uen_no: "",
            country_code: "",
            contact_no: "",
            address: "",
            terms: "",
        },
    });
    const {
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = methods;
    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setShowCrop(true);
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    };
    const updateAasetup = async (aaData) => {
        console.log(aaData);
        let imgIconUrl = null;
        if (croppedImage) {
            let blobFile = await dataURItoBlob(croppedImage);
            let formData = new FormData();
            formData.append("file", blobFile, "crop-icon.jpg");
            formData.append("module", "loanproduct");
            let fileRes = await apiAxios.post("/admin/upload/image", formData, {
                headers: {
                    Authorization: `Bearer ${authData?.token}`,
                },
            });
            imgIconUrl = fileRes?.data?.data;
            console.log(imgIconUrl);
        }
        const postData = {
            sno: aaData.s_no,
            logo: imgIconUrl ? imgIconUrl : aaData.logo,
            company_name: aaData.company_name,
            uen_no: aaData.uen_no,
            country_code: aaData.country_code,
            phone_number: aaData.contact_no,
            address: aaData.address,
            terms: aaData.terms,
        };
        const aaResp = await axios.put("/approval/advice/update", postData, {
            headers: {
                Authorization: `Bearer ${authData?.token}`,
            },
        });
        const respCode = aaResp?.data?.resp_code;
        if (respCode === 200) {
            refetch();
            toast.success("Updated Successfully!!!", { autoClose: 2500 });
            setEditMode(false);
        }
    };
    const updateCroppedImage = (img) => {
        setCroppedImage(img);
        setValue("logo", img);
    };
    useEffect(() => {
        if (AAData) {
            setValue("s_no", AAData?.sno);
            setValue("logo", AAData?.logo);
            setValue("company_name", AAData?.company_name);
            setValue("uen_no", AAData?.uen_no);
            setValue("country_code", AAData?.country_code);
            setValue("contact_no", AAData?.phone_number);
            setValue("address", AAData?.address);
            setValue("terms", AAData?.terms);
        }
    }, [AAData]);
    if (isLoading) {
        return <PageLoader />;
    }
    return (
        <>
            {showCrop ? (
                <CropPopup
                    image={image}
                    setActive={setShowCrop}
                    setImage={updateCroppedImage}
                />
            ) : null}
            <form onSubmit={handleSubmit(updateAasetup)}>
                <h1 className="pt-[20px] pl-[30px] text-[20px] font-[700] mb-[20px] flex items-center gap-[13px]">
                    <img
                        src="/images/left-circle.svg"
                        alt="arrow"
                        className="cursor-pointer"
                        onClick={() => setEditMode(false)}
                    />{" "}
                    Edit AA Details
                </h1>
                <div className="p-[12px_30px] flex items-center gap-[15px] justify-between border-y border-[#EAEAEA]">
                    <h3 className="text-[14px] font-[600]">
                        Approval Advice (AA) Details
                    </h3>
                </div>
                <div className="aa_details p-[20px_30px]">
                    <Controller
                        name="logo"
                        control={control}
                        rules={{
                            required: true,
                        }}
                        render={({ field }) => {
                            return (
                                <div
                                    className={`inline-block w-[120px] h-[80px] rounded-[6px] border mb-[10px] overflow-hidden ${errors?.logo ? "border-[#ff4d4f]" : "border-[#DEDEDE]"
                                        }`}
                                >
                                    <img
                                        className="h-full w-full object-cover"
                                        src={
                                            croppedImage
                                                ? croppedImage
                                                : AAData?.logo
                                                    ? `${IMAGE_BASE_URL}/${AAData?.logo}`
                                                    : ""
                                        }
                                        alt="logo"
                                    />
                                </div>
                            );
                        }}
                    />
                    <div>
                        <input
                            type="file"
                            className="hidden"
                            id="logoImg"
                            onChange={(event) => onImageChange(event)}
                        />
                        <Button className="flex h-[unset] gap-[10px] items-center border-[#0F59F9] text-[#0F59F9] font-[600] text-[13px] p-[0]">
                            <label className="p-[7px_18px] cursor-pointer" htmlFor="logoImg">
                                Change Logo
                            </label>
                        </Button>
                    </div>
                    <div className="max-w-[600px] mt-[30px]">
                        <div className="frm_inp_box mb-[20px]">
                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] flex items-center">
                                S No.
                                <Popover content={"coming soon!"}>
                                    <img
                                        src="/images/fi_info.svg"
                                        alt="info"
                                        className="inline-block ml-[8px] cursor-pointer"
                                    />
                                </Popover>
                            </label>
                            <div className="flex items-center gap-[20px]">
                                <Controller
                                    control={control}
                                    name="s_no"
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => {
                                        return (
                                            <Input
                                                {...field}
                                                status={errors?.s_no ? "error" : null}
                                                className="h-[40px] border-[#C3D2E2!important]"
                                            />
                                        );
                                    }}
                                />
                                <Input
                                    className="h-[40px] border-[#C3D2E2!important] aacusInp"
                                    value="xxxxx"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="frm_inp_box mb-[20px]">
                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                Name of Company
                            </label>
                            <Controller
                                control={control}
                                name="company_name"
                                rules={{
                                    required: true,
                                }}
                                render={({ field }) => {
                                    return (
                                        <Input
                                            {...field}
                                            status={errors?.company_name ? "error" : null}
                                            className="h-[40px] border-[#C3D2E2!important]"
                                        />
                                    );
                                }}
                            />
                        </div>
                        <div className="flex items-center gap-[20px] flex-wrap">
                            <div className="frm_inp_box mb-[20px] flex-[1]">
                                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                    UEN No.
                                </label>
                                <Controller
                                    control={control}
                                    name="uen_no"
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => {
                                        return (
                                            <Input
                                                {...field}
                                                status={errors?.uen_no ? "error" : null}
                                                className="h-[40px] border-[#C3D2E2!important]"
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <div className="frm_inp_box mb-[20px]">
                                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                    Country Code
                                </label>
                                <Controller
                                    control={control}
                                    name="country_code"
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => {
                                        return (
                                            <Select
                                                {...field}
                                                status={errors?.country_code ? "error" : null}
                                                className="aacusSelect"
                                                options={[
                                                    {
                                                        value: "+65",
                                                        label: "+65",
                                                    },
                                                    {
                                                        value: "+45",
                                                        label: "+45",
                                                    },
                                                    {
                                                        value: "+91",
                                                        label: "+91",
                                                    },
                                                ]}
                                                suffixIcon={<img src="/images/selecArr.svg" />}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <div className="frm_inp_box mb-[20px] flex-[1]">
                                <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                    Enquires Contact No
                                </label>
                                <Controller
                                    control={control}
                                    name="contact_no"
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => {
                                        return (
                                            <Input
                                                {...field}
                                                //type="number"
                                                maxLength={10}
                                                status={errors?.contact_no ? "error" : null}
                                                className="h-[40px] border-[#C3D2E2!important]"
                                                onChange={(e) => {
                                                    const { value: inputValue } = e.target;
                                                    const reg = /^-?\d*(\.\d*)?$/;
                                                    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
                                                        setValue("contact_no", inputValue);
                                                    }
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </div>
                        </div>
                        <div className="frm_inp_box mb-[20px]">
                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                Address
                            </label>
                            <Controller
                                control={control}
                                name="address"
                                rules={{
                                    required: true,
                                }}
                                render={({ field }) => {
                                    return (
                                        <TextArea
                                            {...field}
                                            status={errors?.address ? "error" : null}
                                            className="h-[60px!important] border-[#C3D2E2!important]"
                                        />
                                    );
                                }}
                            />
                        </div>
                        <div className="frm_inp_box mb-[20px]">
                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">
                                Terms and Conditions
                            </label>
                            <Controller
                                control={control}
                                name="terms"
                                rules={{
                                    required: true,
                                }}
                                render={({ field }) => {
                                    return (
                                        <TextArea
                                            {...field}
                                            status={errors?.terms ? "error" : null}
                                            className="h-[400px!important] border-[#C3D2E2!important]"
                                        />
                                    );
                                }}
                            />
                        </div>
                    </div>
                    <div className="text-end">
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="font-[600] h-[40px] bg-[#055FFB]"
                        >
                            Save and Preview
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default Aaedit;
